'use client';

import '@web/utils/fbc';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum-slim';
import { LazyMotion, domAnimation } from 'motion/react';
import { PropsWithChildren } from 'react';

import { zendesk } from '@flipster/features/src/shared/zendesk/url';
import { datadogInit } from '@flipster/utils/datadog';
import { getServerEnv, isBuild, isVercelLive } from '@flipster/utils/env-helper';
import segment from '@flipster/utils/segment';
import { getSegmentKey } from '@flipster/utils/segment/config';

// use client 필수!! 제거시 세그먼트 데이터독 동작안함
zendesk.setEnv(process.env.NEXT_PUBLIC_SERVER_URL);
segment.load(getSegmentKey('web', getServerEnv()));
if (isBuild && !isVercelLive) {
  datadogInit(datadogRum, datadogLogs, {
    service: 'prex-frontend-nextjs',
    sessionReplaySampleRate: 20,
    applicationId: '33561c12-5347-40f5-b2b6-b0fb60ea0a18',
    clientToken: 'pub2db2647312d281299307d81d032af56b',
    env: getServerEnv(),
    version: process.env.NEXT_PUBLIC_VERSION ?? 'test',
    beforeSend(event) {
      if (event.type === 'error') {
        // PiP 으로 인해서 무조건 발생할수 있는 에러는 제외
        return (
          event.error.message !==
          "NotAllowedError: Failed to execute 'requestWindow' on 'DocumentPictureInPicture': Document PiP requires user activation"
        );
      }
      return true;
    },
  });
}

const Template = ({ children }: PropsWithChildren) => {
  return (
    <LazyMotion features={domAnimation} strict>
      {children}
    </LazyMotion>
  );
};

export default Template;
